import React, {useState} from 'react'
import moment from 'moment'
import Tabla from '../componentes/Tabla'

const VerInforme = ({data, seleccionaRegistro, cargando}) => {

	const [columns] = useState([
        {
            title: '#',  cellStyle: { minWidth: 1 }, render: (rowData) => rowData.tableData.id + 1
        },
        { title: 'fecha', field: "fecha_ins", cellStyle: { minWidth: 10 }, render: (rowData) => <span>{moment(rowData.fecha_ins).format('DD-MM-YYYY')}</span>},
        { title: 'usuario', field: "usuario" },
        { title: 'Estado', field: "activo", render: (rowData) => <div className={`estados ${rowData.activo}`} >{rowData.activo}</div> },
		{ title: 'nombre', field: "nombre" },
		{ title: 'pais', field: "pais" },
		{ title: 'Estado/Dep', field: "departamento" },
		{ title: 'ciudad', field: "ciudad" },
		{ title: 'telefono', field: "telefono", cellStyle: { minWidth: 50 }  },
		{ title: 'cursos', field: "cursos_nombres", cellStyle: { minWidth: 150 }  }
    ]);

	return(
		<div>
				<Tabla columns={columns} data={data} title='Informe de Usuarios' />
		</div>
	)
}

export default VerInforme